import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=55634d4c&scoped=true&"
import script from "./Campaign.vue?vue&type=script&lang=ts&"
export * from "./Campaign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55634d4c",
  null
  
)

export default component.exports